<template>
  <div class="login-container">
    <!-- <img src="bird-logo.png" class="birdLogo" alt="" /> -->
    <div class="maxxifiedLogoContainer">
      <img :src="maxxifiedLogo" class="newLogo" alt="" />
    </div>

    <p class="loginTitleNew">Forgot Password</p>
    <p class="loginSuitTitleNew">
      {{ step === 1 ? 'Please Enter your username to set up a new password.' : 'Reset Your Password' }}
    </p>

    <div class="login-card2">
      <div class="login-card-inner-section">
        <custom-input v-if="step === 1" label="Username" type="email" placeholder="Please enter your Email ID" :value="email" @update:value="email = $event" :error="fieldErrors.email" />

        <template v-if="step === 2">
          <custom-input label="Enter OTP received on your Email" type="number" placeholder="OTP" :value="otp" @update:value="otp = $event" :error="fieldErrors.otp" />

          <div style="margin-top: 30px">
            <div class="password-input-wrapper">
              <custom-input label="New Password" :type="showNewPassword ? 'text' : 'password'" placeholder="Enter new password" :value="newPassword" @update:value="newPassword = $event" :error="fieldErrors.newPassword" />
              <button type="button" class="password-toggle-btn" @click="showNewPassword = !showNewPassword">
                <svg v-if="showNewPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </button>
            </div>
            <ul class="password-rules">
              <li v-for="rule in newPasswordRules" :key="rule.label" :class="{ valid: rule.valid }">
                <span class="rule-icon">{{ rule.valid ? '✓' : '○' }}</span>
                <span>{{ rule.label }}</span>
              </li>
            </ul>
          </div>
          <div style="margin-top: 30px">
            <div class="password-input-wrapper">
              <custom-input label="Confirm Password" :type="showConfirmPassword ? 'text' : 'password'" placeholder="Confirm new password" :value="confirmPassword" @update:value="confirmPassword = $event" :error="fieldErrors.confirmPassword" />
              <ul class="password-rules">
                <li :class="{ valid: passwordsMatch }">
                  <span class="rule-icon">{{ passwordsMatch ? '✓' : '○' }}</span>
                  <span>Passwords match</span>
                </li>
              </ul>
              <button type="button" class="password-toggle-btn" @click="showConfirmPassword = !showConfirmPassword">
                <svg v-if="showConfirmPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </button>
            </div>
          </div>
        </template>

        <div class="buttonDiv">
          <custom-button :disabled="loading" @click="handleSubmit">
            {{ step === 1 ? 'Next' : 'Reset Password' }}
            <div v-if="loading" class="spinner-border text-white spinner-grow-sm" role="status"></div>
          </custom-button>
        </div>
        <div v-if="step === 2" class="buttonDiv">
          <custom-button :disabled="!canResend || resendLoading" @click="resendOTP" style="width: 100%">
            {{ resendLoading ? 'Sending...' : canResend ? 'Resend OTP' : `Resend OTP in ${resendTimer}s` }}
            <div v-if="resendLoading" class="spinner-border text-white spinner-grow-sm" role="status"></div>
          </custom-button>
        </div>
      </div>
    </div>

    <p class="goBackLabel" @click="goBack">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M20 12H4M4 12L10 6M4 12L10 18" stroke="#32393E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      Back To Login
    </p>

    <!-- <div v-if="error" class="alert alert-danger m-3">{{ error }}</div>
    <div v-if="message" class="alert alert-success m-3">{{ message }}</div> -->
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/authStore'
import CustomInput from '../../components/CustomInput.vue'
import CustomButton from '../../components/CustomButton.vue'
import { showToast } from '@/utils/toast.js'
import maxxifiedLogo from '@/assets/vasionLogin.png'

export default {
  data() {
    return {
      step: 1, // Step 1: Enter Email, Step 2: Enter OTP & Password
      email: '',
      otp: '',
      newPassword: '',
      confirmPassword: '',
      showNewPassword: false,
      showConfirmPassword: false,
      loading: false,
      isSubmitting: false,
      error: null,
      message: null,
      fieldErrors: {
        email: '',
        otp: '',
        newPassword: '',
        confirmPassword: '',
      },
      resendLoading: false,
      resendTimer: 0,
      canResend: false,
      maxxifiedLogo,
    }
  },
  components: {
    CustomInput,
    CustomButton,
  },
  computed: {
    auth() {
      return useAuthStore()
    },
    newPasswordRules() {
      const p = this.newPassword || ''
      return [
        { label: 'Minimum 8 characters', valid: p.length >= 8 },
        { label: 'One capital letter', valid: /[A-Z]/.test(p) },
        { label: 'One small letter', valid: /[a-z]/.test(p) },
        { label: 'One special character', valid: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(p) },
      ]
    },
    passwordsMatch() {
      if (!this.newPassword || !this.confirmPassword) return false
      return this.newPassword === this.confirmPassword
    },
  },
  methods: {
    validateNewPassword(password) {
      const errors = []
      if (!password || password.length < 8) {
        errors.push('Password must be at least 8 characters.')
      }
      if (!/[A-Z]/.test(password)) {
        errors.push('Password must contain at least one capital letter.')
      }
      if (!/[a-z]/.test(password)) {
        errors.push('Password must contain at least one small letter.')
      }
      if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) {
        errors.push('Password must contain at least one special character.')
      }
      return errors
    },
    startResendTimer() {
      this.resendTimer = 30
      this.canResend = false
      const interval = setInterval(() => {
        this.resendTimer--
        if (this.resendTimer <= 0) {
          clearInterval(interval)
          this.canResend = true
        }
      }, 1000)
    },
    async resendOTP() {
      if (!this.canResend || this.resendLoading) return

      this.resendLoading = true
      try {
        const response = await this.auth.forgotPassword(this.email)
        if (response?.data?.code === 200) {
          showToast({
            title: 'Success',
            message: 'OTP resent successfully to your email.',
            type: 'success',
          })
          this.startResendTimer()
        } else {
          showToast({
            title: 'Error',
            message: response?.data?.message || 'Failed to resend OTP.',
            type: 'error',
          })
        }
      } catch (error) {
        showToast({
          title: 'Error',
          message: error?.response?.data?.message || 'An error occurred.',
          type: 'error',
        })
      }
      this.resendLoading = false
    },

    goBack() {
      this.$router.push('/login')
    },
    async handleSubmit() {
      if (this.isSubmitting) {
        return // Prevent multiple submissions
      }

      this.isSubmitting = true
      this.error = null
      this.message = null

      if (this.step === 1) {
        this.fieldErrors = {
          email: '',
          otp: '',
          newPassword: '',
          confirmPassword: '',
        }

        if (!this.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
          this.fieldErrors.email = 'Please enter valid email Id'
          return
        } else {
          this.loading = true
          try {
            const response = await this.auth.forgotPassword(this.email)
            if (response?.data?.code === 200) {
              this.message = 'Password reset code sent successfully.'
              this.isSubmitting = false
              this.step = 2
              this.startResendTimer()
            } else {
              this.error = response?.data?.message || 'Failed to send OTP. Please try again.'
            }
          } catch (error) {
            this.error = error?.response?.data?.message || 'An error occurred. Please try again.'
          }
          this.loading = false
        }
      } else {
        this.fieldErrors = {
          email: '',
          otp: '',
          newPassword: '',
          confirmPassword: '',
        }

        let valid = true

        if (!this.otp) {
          this.fieldErrors.otp = 'OTP is required.'
          valid = false
        }
        if (!this.newPassword) {
          this.fieldErrors.newPassword = 'New password is required.'
          valid = false
        }
        if (!this.confirmPassword) {
          this.fieldErrors.confirmPassword = 'Confirm your password.'
          valid = false
        } else if (this.newPassword !== this.confirmPassword) {
          this.fieldErrors.confirmPassword = 'Passwords do not match.'
          valid = false
        }

        const passwordErrors = this.validateNewPassword(this.newPassword)
        if (passwordErrors.length) {
          this.fieldErrors.newPassword = passwordErrors[0]
          valid = false
        }

        if (!valid) {
          this.isSubmitting = false
          return
        }

        this.loading = true
        try {
          const response = await this.auth.resetPassword(this.email, this.otp, this.newPassword)
          if (response?.data?.code === 200) {
            this.message = 'Password reset successfully! Redirecting to login...'
            showToast({
              title: 'Success',
              message: 'Password reset successfully! You can login now.',
              type: 'success',
            })
            setTimeout(() => {
              this.$router.push('/login')
            }, 2000)
          } else {
            this.fieldErrors.confirmPassword = response?.data?.message || 'Password reset failed. Please try again.'
            this.error = response?.data?.message || 'Password reset failed. Please try again.'
          }
        } catch (error) {
          this.error = error?.response?.data?.message || 'An error occurred. Please try again.'
        }
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
@import '@/styles/login.css';

.password-input-wrapper {
  position: relative;
  width: 100%;
}

.password-input-wrapper :deep(.input-wrapper input) {
  padding-right: 45px;
}

.password-toggle-btn {
  position: absolute;
  right: 12px;
  top: calc(19.58px + 10px + 5px + 23px);
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667085;
  z-index: 10;
  transition: color 0.2s;
  height: 20px;
  width: 20px;
  margin-top: 0;
}

.password-toggle-btn:hover {
  color: var(--primary-color, #164863);
}

.password-toggle-btn:focus {
  outline: none;
}

.password-toggle-btn svg {
  width: 20px;
  height: 20px;
  stroke-width: 2;
}

.password-rules {
  list-style: none;
  padding: 0;
  margin: 8px 0 0;
}

.password-rules li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #667085;
  margin-bottom: 4px;
}

.password-rules li.valid {
  color: #0f9d58;
}

.password-rules .rule-icon {
  font-size: 14px;
  font-weight: bold;
  min-width: 18px;
  text-align: center;
}

.password-rules li .rule-icon {
  color: #667085;
}

.password-rules li.valid .rule-icon {
  color: #0f9d58;
}
</style>
